import BaseModal from 'flow/components/ui-components/BaseModal';
import { useModal } from 'flow/contexts/ModalProvider';
import useAppContext from 'flow/hooks/useAppContext';
import { TicketKey } from 'flow/types/EntityKeys';
import TicketMembers from './TicketMembers';

interface Props {
    ticketKey?: TicketKey;
    onClose?: () => void;
}

const TicketMembersModal = ({ ticketKey, onClose }: Props) => {
    const { i18next } = useAppContext();
    const { openModal } = useModal();

    return (
        <BaseModal
            open={true}
            header={i18next.t('chatsettings.members')}
            onClose={onClose}
            className="min-h-[50dvh]"
            hideCancelButton={true}
            confirmButtonText={i18next.t('chatsettings.add_member')}
            onContinue={() =>
                openModal('addTicketMembers', {
                    ticketKey,
                    onClose: () => {},
                })
            }
        >
            <TicketMembers ticketKey={ticketKey} />
        </BaseModal>
    );
};

export default TicketMembersModal;
